import css from "styled-jsx/css";
import { MAX_DESKTOP_GRID_WIDTH } from "constants/vp-sizes";

const CONTAINER_HEIGHT = 550;
const CONTAINER_HEIGHT_PX = `${CONTAINER_HEIGHT}px`;

export const componentStyles = css.global`
  .timer-vertical-tabs-desktop-component {
    max-width: ${MAX_DESKTOP_GRID_WIDTH + "px"};
    width: 85%;
    margin: 0 auto;
    padding: 8px 0px;

    .vertical-timer-tabs-container {
      display: flex;

      .desktop-tabs-text-container {
        margin-right: 75px;
        min-height: ${CONTAINER_HEIGHT_PX};
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .desktop-asset-container {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .tab-asset-inner {
          align-self: flex-end;
          display: flex;
          width: 760px;
          height: ${CONTAINER_HEIGHT_PX};
          padding: 28px;

          .tab-asset-image {
            max-width: 100%;
            max-height: ${CONTAINER_HEIGHT_PX};
            width: auto;
          }
        }
      }
      .fade-enter {
        opacity: 0;
      }
      .fade-exit {
        opacity: 1;
      }
      .fade-enter-active {
        opacity: 1;
      }
      .fade-exit-active {
        opacity: 0;
      }
      .fade-enter-active,
      .fade-exit-active {
        transition: opacity 200ms;
      }
    }

    .button-link {
      margin-top: 40px;
    }
  }
`;
